// themeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const getInitialTheme = () => {
  const stored = localStorage.getItem("isDarkMode");
  // return stored !== null ? JSON.parse(stored) : true;
  return stored !== null ? true : true;

};

const initialState = {
  darkMode: getInitialTheme(),
  reFetchKey: null,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem("isDarkMode", JSON.stringify(state.darkMode));
    },

    setTheme: (state, action) => {
      state.darkMode = action.payload;
      localStorage.setItem("isDarkMode", JSON.stringify(state.darkMode));
    },

    setReFetchKey: (state, action) => {
      state.reFetchKey = action.payload || null;
    },

    toggleReFetch: (state, action) => {
      state.reFetchKey = action.payload || null;
    },
  },
});

export const { toggleTheme, setTheme, setReFetchKey, toggleReFetch } =
  themeSlice.actions;

export default themeSlice.reducer;
